import { ChangePasswordFormFields } from '@anm/components/form/ChangePasswordForm';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { userActions } from '../../store/modules/user';

const useChangePasswordHandler = () => {
  const dispatch = useDispatch();

  const handleChangePassword = useCallback(
    ({ currentPassword, newPassword }: ChangePasswordFormFields) => {
      dispatch(
        userActions.changePassword({
          current_password: currentPassword,
          new_password: newPassword
        })
      );
    },
    []
  );

  return handleChangePassword;
};

export default useChangePasswordHandler;
